import { render, staticRenderFns } from "./MatrixCompose.vue?vue&type=template&id=10aed7e3&scoped=true"
import script from "./MatrixCompose.vue?vue&type=script&lang=js"
export * from "./MatrixCompose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aed7e3",
  null
  
)

export default component.exports